module.exports = __webpack_public_path__ + "static/EnmedioPuas-c58c3156ec9f9d3bcb7e403cf4f8dd91.png";